/** Catálogo maestro de obligaciones — nombres limpios y filtros. */
import { obligationAuthorityLabel } from "@/modules/despacho/despachoFiscalInfoHelpers";

export const OBLIGATION_AUTHORITY_FILTERS = [
  { key: "all", label: "Todos" },
  { key: "SAT", label: "SAT" },
  { key: "IMSS", label: "IMSS" },
  { key: "INFONAVIT", label: "INFONAVIT" },
  { key: "REPSE", label: "REPSE" },
  { key: "Estatal", label: "Estatal" },
  { key: "Municipal", label: "Municipal" },
  { key: "Interna", label: "Interna" },
];

export const DEACTIVATION_REASONS = [
  { value: "ya_no_aplica", label: "Ya no aplica" },
  { value: "cambio_regimen", label: "Cambio de régimen" },
  { value: "sin_actividad", label: "Cliente sin actividad" },
  { value: "error_asignacion", label: "Error de asignación" },
  { value: "constancia_actualizada", label: "Constancia actualizada" },
  { value: "otro", label: "Otro" },
];

const AUTHORITY_SUFFIX_RE = /\s*[·|]\s*(SAT|IMSS|INFONAVIT|REPSE|Estatal|Municipal|Interna)\s*$/i;

export function obligationVisibleName(row) {
  if (!row) return "";
  const raw =
    row.nombre_visible ||
    row.short_name ||
    row.full_name ||
    row.nombre_completo ||
    row.id ||
    "";
  return String(raw).replace(AUTHORITY_SUFFIX_RE, "").trim();
}

export function isObligationRowActive(row) {
  return row && row.status !== "inactive" && row.active !== false;
}

export function filterCatalogItems(items, { authority = "all", query = "", assignmentMap = {} } = {}) {
  const q = String(query || "").trim().toLowerCase();
  const auth = String(authority || "all");
  return (items || []).filter((item) => {
    if (auth !== "all" && String(item.authority || "") !== auth) return false;
    if (assignmentMap[item.id]?.state === "active") return false;
    if (q) {
      const hay = [
        obligationVisibleName(item),
        item.nombre_completo,
        item.categoria,
        item.authority,
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      if (!hay.includes(q)) return false;
    }
    return true;
  }).map((item) => ({
    ...item,
    assignment: assignmentMap[item.id] || { state: "unassigned" },
  }));
}

export function buildAssignmentMap(obligations = []) {
  const map = {};
  for (const row of obligations) {
    const cid = row.obligation_catalog_id;
    if (!cid) continue;
    const active = isObligationRowActive(row);
    map[cid] = {
      state: active ? "active" : "inactive",
      row,
      source: row.source,
    };
  }
  return map;
}

export function obligationAuthorityMeta(authority) {
  return obligationAuthorityLabel(authority);
}
